/* SNUG Global Clean — Commerce JS (Lane B)
   product gallery + variants + sticky ATC, collection quick-add/sort, cart AJAX. */
(function () {
  'use strict';
  if (window.__sgcCommerceInit) return;
  window.__sgcCommerceInit = true;

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  function moneyFmt(cents, currency) {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD' }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function updateHeaderCartCount(count) {
    var icon = $('.sg-header__icon--cart') || $('.cart-icon');
    if (!icon) return;
    var badge = icon.querySelector('.sg-header__cart-count');
    if (count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'sg-header__cart-count';
        icon.appendChild(badge);
      }
      badge.textContent = count;
    } else if (badge) {
      badge.remove();
    }
  }

  /* ============ PRODUCT PAGE ============ */
  function initProduct() {
    var root = $('[data-sgc-product]');
    if (!root) return;

    var currency = root.getAttribute('data-currency') || 'USD';
    var variants = [];
    try { variants = JSON.parse($('[data-sgc-variants]', root).textContent); } catch (e) {}

    /* --- gallery --- */
    var mainImg = $('[data-sgc-main-img]', root);
    var thumbs = $$('.sgc-thumb', root);
    function setMainImage(src, srcset) {
      if (!mainImg || !src) return;
      mainImg.classList.add('sgc-fading');
      setTimeout(function () {
        mainImg.src = src;
        if (srcset) mainImg.srcset = srcset; else mainImg.removeAttribute('srcset');
        mainImg.onload = function () { mainImg.classList.remove('sgc-fading'); };
        setTimeout(function () { mainImg.classList.remove('sgc-fading'); }, 450);
      }, 180);
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        setMainImage(t.getAttribute('data-full'), t.getAttribute('data-full-srcset'));
      });
    });

    /* lightbox */
    var lightbox = $('[data-sgc-lightbox]');
    var galleryMain = $('.sgc-gallery__main', root);
    if (galleryMain && lightbox) {
      galleryMain.addEventListener('click', function () {
        var img = lightbox.querySelector('img');
        img.src = mainImg.getAttribute('data-zoom') || mainImg.src;
        lightbox.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });
      lightbox.addEventListener('click', function () {
        lightbox.classList.remove('is-open');
        document.body.style.overflow = '';
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && lightbox.classList.contains('is-open')) {
          lightbox.classList.remove('is-open');
          document.body.style.overflow = '';
        }
      });
    }

    /* --- variant selection --- */
    var form = $('form[data-sgc-form]', root);
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var optionWraps = $$('[data-sgc-option]', root);

    function selectedOptions() {
      return optionWraps.map(function (w) {
        var active = w.querySelector('.sgc-pill-btn.is-active');
        if (active) return active.getAttribute('data-value');
        var sel = w.querySelector('select');
        return sel ? sel.value : null;
      });
    }

    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], match = true;
        for (var j = 0; j < opts.length; j++) {
          if (v.options[j] !== opts[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function renderVariant(v) {
      var atcBtn = $('[data-sgc-atc]', root);
      var stickyBtn = $('[data-sgc-sticky-atc]');
      if (!v) {
        if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = v.id;

      /* price row(s) */
      $$('[data-sgc-price]', document).forEach(function (el) { el.textContent = moneyFmt(v.price, currency); });
      $$('[data-sgc-compare]', document).forEach(function (el) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          el.textContent = moneyFmt(v.compare_at_price, currency);
          el.style.display = '';
        } else { el.style.display = 'none'; }
      });
      var pricEls = $$('[data-sgc-price]', document);
      pricEls.forEach(function (el) {
        el.classList.toggle('is-sale', !!(v.compare_at_price && v.compare_at_price > v.price));
      });
      var savePill = $('[data-sgc-save]', root);
      if (savePill) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          var save = v.compare_at_price - v.price;
          var pct = Math.round(save * 100 / v.compare_at_price);
          savePill.textContent = 'Save ' + moneyFmt(save, currency) + ' (' + pct + '%)';
          savePill.style.display = '';
        } else { savePill.style.display = 'none'; }
      }

      /* honest low stock */
      var stock = $('[data-sgc-stock]', root);
      if (stock) {
        if (v.managed && v.policy !== 'continue' && v.qty > 0 && v.qty < 5) {
          stock.innerHTML = '<span class="sgc-lowstock"><span class="sgc-dot"></span>Only ' + v.qty + ' left in stock</span>';
        } else {
          stock.innerHTML = '';
        }
      }

      /* availability */
      if (atcBtn) {
        atcBtn.disabled = !v.available;
        atcBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
      }
      if (stickyBtn) {
        stickyBtn.disabled = !v.available;
        stickyBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
      }

      /* variant image */
      if (v.image) {
        var match = thumbs.filter(function (t) { return t.getAttribute('data-full') === v.image; })[0];
        if (match) { match.click(); } else { setMainImage(v.image); }
      }

      /* URL */
      if (history.replaceState && variants.length > 1) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }

    optionWraps.forEach(function (w) {
      $$('.sgc-pill-btn', w).forEach(function (btn) {
        btn.addEventListener('click', function () {
          $$('.sgc-pill-btn', w).forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          renderVariant(findVariant(selectedOptions()));
        });
      });
      var sel = w.querySelector('select');
      if (sel) sel.addEventListener('change', function () { renderVariant(findVariant(selectedOptions())); });
    });

    /* --- qty stepper --- */
    initQtySteppers(root);

    /* --- AJAX add to cart --- */
    var msgEl = $('[data-sgc-atc-msg]', root);
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var atcBtn = $('[data-sgc-atc]', root);
        var original = atcBtn ? atcBtn.textContent : '';
        if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = 'Adding…'; }
        var fd = new FormData(form);
        fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
          .then(function (r) { if (!r.ok) throw r; return r.json(); })
          .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
          .then(function (cart) {
            updateHeaderCartCount(cart.item_count);
            if (atcBtn) { atcBtn.textContent = 'Added ✓'; }
            if (msgEl) msgEl.innerHTML = 'Added to your cart — <a href="/cart">view cart</a> or <a href="/checkout">checkout now</a>.';
            setTimeout(function () {
              if (atcBtn) { atcBtn.disabled = false; atcBtn.textContent = original; }
            }, 1800);
          })
          .catch(function (err) {
            if (err && err.json) {
              err.json().then(function (j) {
                if (msgEl) { msgEl.style.color = '#B4674A'; msgEl.textContent = j.description || 'Could not add to cart.'; }
              });
            } else if (msgEl) { msgEl.style.color = '#B4674A'; msgEl.textContent = 'Could not add to cart. Please try again.'; }
            if (atcBtn) { atcBtn.disabled = false; atcBtn.textContent = original; }
          });
      });
    }

    /* --- sticky mobile ATC bar --- */
    var sticky = $('[data-sgc-sticky]');
    var buybox = $('.sgc-buy-row', root);
    if (sticky && buybox && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var ent = entries[0];
        var below = ent.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', !ent.isIntersecting && below);
      }, { threshold: 0 });
      io.observe(buybox);
      var stickyBtn2 = $('[data-sgc-sticky-atc]');
      if (stickyBtn2 && form) {
        stickyBtn2.addEventListener('click', function () {
          if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
        });
      }
    }

    /* initial render for preselected variant */
    var initial = null;
    var urlVar = new URL(window.location.href).searchParams.get('variant');
    if (urlVar) initial = variants.filter(function (v) { return String(v.id) === urlVar; })[0];
    if (!initial && idInput) initial = variants.filter(function (v) { return String(v.id) === idInput.value; })[0];
    if (initial && variants.length > 1) {
      optionWraps.forEach(function (w, i) {
        var val = initial.options[i];
        var btn = $$('.sgc-pill-btn', w).filter(function (b) { return b.getAttribute('data-value') === val; })[0];
        if (btn) { $$('.sgc-pill-btn', w).forEach(function (b) { b.classList.remove('is-active'); }); btn.classList.add('is-active'); }
        var sel = w.querySelector('select');
        if (sel) sel.value = val;
      });
      renderVariant(initial);
    }
  }

  function initQtySteppers(scope) {
    $$('.sgc-qty', scope || document).forEach(function (q) {
      if (q.__sgcBound) return;
      q.__sgcBound = true;
      var input = q.querySelector('input');
      q.addEventListener('click', function (e) {
        var btn = e.target.closest('button');
        if (!btn) return;
        e.preventDefault();
        var step = btn.getAttribute('data-step') === 'up' ? 1 : -1;
        var min = parseInt(input.getAttribute('min') || '1', 10);
        var val = (parseInt(input.value, 10) || min) + step;
        if (val < min) val = min;
        input.value = val;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* ============ COLLECTION: quick add + hover swap + sort ============ */
  function initCollection() {
    /* SPD-4: hover-image carries data-src only. Swap to real src on first
       mouseenter, hover-capable devices only — mobile never fetches it. */
    if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
      $$('.sgc-card__img--hover').forEach(function (img) {
        var card = img.closest('.sgc-card');
        if (!card) return;
        card.addEventListener('mouseenter', function once() {
          if (img.getAttribute('data-src')) {
            if (img.getAttribute('data-srcset')) img.srcset = img.getAttribute('data-srcset');
            if (img.getAttribute('data-sizes')) img.sizes = img.getAttribute('data-sizes');
            img.src = img.getAttribute('data-src');
            img.removeAttribute('data-src');
          }
          card.removeEventListener('mouseenter', once);
        }, { once: true });
      });
    }

    $$('[data-sgc-quickadd]').forEach(function (btn) {
      var isIcon = btn.hasAttribute('data-sgc-icon');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var vid = btn.getAttribute('data-variant-id');
        var url = btn.getAttribute('data-url');
        if (!vid) { window.location.href = url; return; }
        var original = isIcon ? null : btn.textContent;
        if (isIcon) { btn.classList.add('is-busy'); }
        else { btn.textContent = 'Adding…'; btn.disabled = true; }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
        })
          .then(function (r) { if (!r.ok) throw r; return r.json(); })
          .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
          .then(function (cart) {
            updateHeaderCartCount(cart.item_count);
            if (isIcon) {
              btn.classList.remove('is-busy');
              btn.classList.add('is-added');
              setTimeout(function () { btn.classList.remove('is-added'); }, 1600);
            } else {
              btn.textContent = 'Added ✓';
              setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1600);
            }
          })
          .catch(function () { window.location.href = url; });
      });
    });

    var sort = $('[data-sgc-sort]');
    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }
  }

  /* ============ CART PAGE ============ */
  function initCart() {
    var root = $('[data-sgc-cart]');
    if (!root) return;
    var currency = root.getAttribute('data-currency') || 'USD';
    var threshold = parseInt(root.getAttribute('data-ship-threshold') || '15000', 10);

    function refresh(cart) {
      updateHeaderCartCount(cart.item_count);
      if (cart.item_count === 0) { window.location.reload(); return; }
      var subtotal = $('[data-sgc-subtotal]', root);
      if (subtotal) subtotal.textContent = moneyFmt(cart.items_subtotal_price, currency);
      var total = $('[data-sgc-total]', root);
      if (total) total.textContent = moneyFmt(cart.total_price, currency);
      /* line totals */
      $$('.sgc-line', root).forEach(function (lineEl) {
        var key = lineEl.getAttribute('data-key');
        var item = cart.items.filter(function (it) { return it.key === key; })[0];
        if (!item) { lineEl.remove(); return; }
        var lt = lineEl.querySelector('[data-sgc-line-total]');
        if (lt) lt.textContent = moneyFmt(item.final_line_price, currency);
        var lc = lineEl.querySelector('[data-sgc-line-compare]');
        if (lc) {
          var unitCmp = parseInt(lc.getAttribute('data-unit-compare') || '0', 10);
          if (unitCmp > 0) {
            lc.textContent = moneyFmt(unitCmp * item.quantity, currency);
          } else if (item.original_line_price > item.final_line_price) {
            lc.textContent = moneyFmt(item.original_line_price, currency);
          }
        }
        var qi = lineEl.querySelector('.sgc-qty input');
        if (qi) qi.value = item.quantity;
      });
      /* shipping bar */
      var fill = $('[data-sgc-ship-fill]', root);
      var label = $('[data-sgc-ship-label]', root);
      if (fill && label) {
        var pct = Math.min(100, Math.round(cart.total_price * 100 / threshold));
        fill.style.width = pct + '%';
        if (cart.total_price >= threshold) {
          label.innerHTML = '<strong>You’ve unlocked free shipping!</strong>';
        } else {
          label.innerHTML = 'You’re <strong>' + moneyFmt(threshold - cart.total_price, currency) + '</strong> away from free shipping';
        }
      }
    }

    function changeLine(key, qty) {
      root.classList.add('is-busy');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(refresh)
        .catch(function () { window.location.reload(); })
        .then(function () { root.classList.remove('is-busy'); });
    }

    initQtySteppers(root);
    $$('.sgc-line', root).forEach(function (lineEl) {
      var key = lineEl.getAttribute('data-key');
      var input = lineEl.querySelector('.sgc-qty input');
      if (input) {
        input.addEventListener('change', function () {
          var q = parseInt(input.value, 10);
          if (isNaN(q) || q < 0) q = 1;
          changeLine(key, q);
        });
      }
      var rm = lineEl.querySelector('[data-sgc-remove]');
      if (rm) rm.addEventListener('click', function (e) { e.preventDefault(); changeLine(key, 0); });
    });
  }

  function init() {
    initProduct();
    initCollection();
    initCart();
    initQtySteppers(document);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
